export enum PaymentType {
  None = 1,
  Cash = 2,
  CreditCard = 3
}
